// src/pages/BackgroundCheckStatus.js
import React from "react";
import { useNavigate } from "react-router-dom";

const BackgroundCheckStatus = () => {
  const navigate = useNavigate();
  const status = localStorage.getItem("backgroundCheckStatus") || "pending"; // "approved", "rejected"

  const getStatusText = () => {
    switch (status) {
      case "approved":
        return "✅ Approved";
      case "rejected":
        return "❌ Rejected";
      case "pending":
      default:
        return "⏳ Pending Review";
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case "approved":
        return "text-green-600";
      case "rejected":
        return "text-red-600";
      case "pending":
      default:
        return "text-gray-500";
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Header */}
      <div className="bg-black text-white p-4 text-xl font-semibold">Background Check</div>

      {/* Status */}
      <div className="flex-1 p-4 text-sm text-gray-800">
        <p>This section contains your uploaded government ID documents used for background verification. Once verified by our team, your status will update automatically.</p>
        <div className={`mt-6 text-lg font-semibold ${getStatusColor()}`}>{getStatusText()}</div>

        {status === "rejected" && (
          <button
            onClick={() => navigate("/upload-documents")}
            className="mt-6 bg-red-600 text-white py-2 px-4 rounded-md font-semibold hover:bg-red-700"
          >
            Re-upload Documents
          </button>
        )}
      </div>
    </div>
  );
};

export default BackgroundCheckStatus;
